import * as React from 'react'

import { twMerge } from 'tailwind-merge'

import ErrorMessage from '@/components/form/ErrorMessage'

const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'>
>(({ className, ...props }, ref) => {
  return (
    <textarea
      data-slot="textarea"
      className={twMerge(
        'text-primary-900 dark:text-primary-100 placeholder:text-primary-500 dark:placeholder:text-primary-400 selection:bg-primary-300 selection:text-primary-700 dark:selection:bg-primary-600 dark:selection:text-primary-100',
        'border-primary-200 dark:border-primary-800 flex min-h-16 w-full min-w-0 rounded-md border px-3 py-2 text-sm bg-primary-50 dark:bg-primary-900 transition-[color,box-shadow] outline-none resize-none',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-accent-400 focus-visible:ring-accent-400 dark:focus-visible:border-accent-400/50 dark:focus-visible:ring-accent-400/50 focus-visible:ring-[2px]',
        'aria-invalid:border-primary-500 aria-invalid:ring-primary-500',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})

const FormTextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & {
    error?: string
    containerClassName?: string
  }
>(({ className, error, containerClassName, ...props }, ref) => {
  return (
    <div className={twMerge('flex flex-col', containerClassName)}>
      <TextArea {...props} className={className} ref={ref} />
      {error && <ErrorMessage className="mt-[2px]">{error}</ErrorMessage>}
    </div>
  )
})

TextArea.displayName = 'TextArea'

FormTextArea.displayName = 'FormTextArea'

export { TextArea, FormTextArea }
